<script setup lang="ts">
import IntegrationDO = App.Data.Integrations.IntegrationDO;
import DeployTeqActivity from "@/modules/integrations/components/IntegrationActivityComponents/DeployTeqActivity.vue";
import { useApiClient } from "@/api/client";
import { useRoute } from "vue-router";
import { onBeforeMount, ref } from "vue";
import IntegrationExecutionDO = App.Data.Integrations.IntegrationExecutionDO;
import RTHADataPlatformActivity from "@/modules/integrations/components/IntegrationActivityComponents/RTHADataPlatformActivity.vue";

const integrationUuid: string = String(useRoute().params.uuid) ?? "";
const isLoading = ref<boolean>(true);
const integrationExecutions = ref<IntegrationExecutionDO[]>([]);

const props = defineProps<{
	integration: IntegrationDO;
}>();

const integrationActivityComponentsMap = {
	deployteq: DeployTeqActivity,
	rtha_dp: RTHADataPlatformActivity,
};

const getActivity = async () => {
	isLoading.value = true;
	const response = await useApiClient("integrations").showActivity(
		integrationUuid
	);
	if (response.isOk()) {
		integrationExecutions.value = response.value.data;
		isLoading.value = false;
	}
};

onBeforeMount(() => getActivity());
</script>

<template>
	<v-card>
		<v-sheet color="grey-lighten-4 d-flex">
			<v-img
				height="200px"
				:src="`${integration?.company_logo}`"
				max-width="344"
				cover
			></v-img>
			<v-divider vertical class="mx-5" />
		</v-sheet>
		<v-divider />
		<component
			v-if="integration"
			:is="integrationActivityComponentsMap[integration.name_clean]"
		/>
	</v-card>
</template>

<style scoped lang="scss"></style>
